import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import AdminAuthCallback from "@/pages/AdminAuthCallback";
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const InvitationPage = lazy(() => import("@/pages/InvitationPage"));
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-[#2A080C] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-amber-400 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/invite/:inviteCode" element={<InvitationPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/auth/callback" element={<AdminAuthCallback />} />
      <Route path="/admin/dashboard" element={
        <ProtectedRoute><AdminDashboard /></ProtectedRoute>
      } />
      <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="/" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-[#2A080C] flex items-center justify-center text-amber-200">Loading Royal Vivah...</div>}>
          <AppRoutes />
        </Suspense>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
